function PostPreviewCtrl(){
	$("#previewBtn").on('click',function(){
		PostPreview();
	});		
	$('select').change(function() { 
		var selected = $(this).find("option:selected").text();
		var id = $(this).attr("id");
		$('[data-unique="'+id+'"] select option').each(function(index){
			$(this).attr('selected', false);
		});		
		$('[data-unique="'+id+'"] select option[value="'+ selected +'"]').attr('selected', true);
	});
	$('input[type="text"]').change(function() { 
		var val = $(this).val();
		var id = $(this).attr("id");
		$('[data-unique="'+id+'"] input[type="text"]').val(val);
	});
}

function LenRandom(){
	var len = 5;
	var str = "abcdefghijklmnopqrstuvwxyz";
	var strLen = str.length;
	var result = "";
	for (var i = 0; i < len; i++) {result += str[Math.floor(Math.random()*strLen)];}
	return result;
}

function PostPreview(){
	var elem = document.getElementById("previmg");
//	elem.src = "images/loader.gif";
	var formData = $("#addinput").serialize();
	var date = new Date();
	var format;
	var random;
	format = 'YYYYMMDDhhmmssaa'        
	format = format.replace(/YYYY/g, date.getFullYear());
	format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
	format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2));
	format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2));
	format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
	format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
	format = format.replace(/aa/g, ('0' + date.getMilliseconds()).slice(-2));
	random = LenRandom();
	formData += "&uniqueID=" + format + random;
	console.log(formData);
	$.ajax({
		type: "POST",
		url: "https://stpm.inbou.com/stamp/makePDF.php",
		data:  formData ,
		dataType: "text",
		scriptCharset: "utf-8"

	}).done(function(data) {
		result = data;
		if( data.match(/_ERROR:/) ) {
			console.log("ER!" + data);
		}else{
			var getAry = data.split("+");
			var filelink	= getAry[1];
			var filePDFlink	= getAry[2];
			if(filelink == "images/noimage.png"){
				elem.src = "./noimage.png";
			}
			else{
				elem.src = filelink+"?";
			}
//				$("#refPDF").attr("href", filePDFlink)
		}

	}).fail(function(data) {
		console.log("ER!");
	});
}